/**
 * Yazdırma öncesi DOM'un hazır olmasını beklemek için yardımcılar.
 *
 * Tarayıcı yazdırmada (react-to-print) etiket sayfaları gerçekten DOM'a
 * çiziliyor ve baskı diyaloğu açılmadan önce yerleşimin bitmesi, görsellerin
 * yüklenmesi gerekiyor.
 */

/** İki kare bekler: ilkinde React yazar, ikincisinde tarayıcı yerleşimi yapar */
export function nextFrame(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
}

/**
 * Tarayıcıya bir kare boyunca söz hakkı verir.
 *
 * Sayfa çizimi ve PNG kodlama ana iş parçacığında; işleri arka arkaya
 * sıraladığımızda React hiç render edemiyor ve arayüz kilitlenmiş görünüyor.
 * Arada bir kare bırakmak ilerleme göstergesinin akmasını sağlıyor.
 */
export function yieldToBrowser(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => setTimeout(resolve, 0));
  });
}

/**
 * Barkod/QR görselleri asenkron üretiliyor — rasterlemeden önce hepsi yüklenmeli.
 *
 * Yalnızca `complete` bakılır: yüklenemeyen görselde de true olur. naturalWidth
 * koşulu eklenirse erişilemeyen bir görsel her etikette zaman aşımı dolana
 * kadar bekletiyor.
 */
export async function waitForImages(root: HTMLElement, timeoutMs = 5000): Promise<void> {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const images = Array.from(root.querySelectorAll('img'));
    if (images.length === 0 || images.every((img) => img.complete)) {
      await nextFrame();
      return;
    }
    await nextFrame();
  }
}
